export const NOT_APPLICABLE = "Not Applicable";
